import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from './Models/User';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient) { }

  login(userName: string, password: string): Observable<any> {
    let formParams = new FormData();

    formParams.append('userName', userName);
    formParams.append('password', password);

    return this.http.post('/api/identity/issue', formParams);
  }

  register(
    userName: string | null | undefined,
    email: string | null | undefined,
    password: string | null | undefined,
    confirmPassword: string | null | undefined): Observable<any> {
    let formParams = new FormData();

    formParams.append('userName', userName!);
    formParams.append('email', email!);
    formParams.append('password', password!);
    formParams.append('confirmPassword', confirmPassword!);

    return this.http.post('/api/identity/register', formParams);
  }

  logout(): Observable<any> {
    return this.http.get('/api/identity/logout');
  }

  isLoggedIn(): Observable<any> {
    return this.http.get('/api/identity/authenticated');
  }

  refreshToken() {
    return this.http.get('/api/identity/refresh', { headers: { 'skip-loading': 'true' } });
  }

  changePassword(newPassword: string) {
    let formParams = new FormData();

    formParams.append('newPassword', newPassword);
    return this.http.post('/api/identity/change-password', formParams);
  }
}
